import { render, staticRenderFns } from "./ColorSchemeCardNew.vue?vue&type=template&id=061d038e&"
import script from "./ColorSchemeCardNew.vue?vue&type=script&lang=ts&"
export * from "./ColorSchemeCardNew.vue?vue&type=script&lang=ts&"
import style0 from "./ColorSchemeCardNew.vue?vue&type=style&index=0&id=061d038e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports